export default Object.freeze({
  INBOX: 'inbox',
  UNREAD: 'unread',
  STARRED: 'starred',
  SNOOZED: 'snoozed',
  SENT: 'sent',
  DRAFT: 'draft',
  TRASH: 'trash'
})
